module.exports = __webpack_public_path__ + "img/heart.df429cd6.png";